module.exports = __webpack_public_path__ + "static/media/avatar50.05c07f67.png";